import { makeStyles } from '@material-ui/core';
import { themeColor } from '../../mui-theme';

export const keypadStyles = makeStyles(() => ({
  container: {
    width: '20.93vw',
    maxWidth: 294,
    backgroundColor: themeColor.white,
    boxShadow: `0 1px 1px 0 ${themeColor.semitransparentblack}`,
    border: `1px solid ${themeColor.secondaryLight}`,
    borderRadius: 2,
    '@media (min-width: 1366px)': {
      maxWidth: 360,
    },
  },
  innerContainer: {
    paddingTop: '1.97vh',
    paddingLeft: '1.46vw',
    paddingRight: '1.46vw',
    width: '100%',
  },
  numpadGridContainer: {
    paddingTop: '4.42vh',
  },
}));
